import RNG from '@/mixins/rng'

const PLACEHOLDER_LIST = {
  clinical_trials: ['NCT02949011'],
  general: [
    'AAV gene therapy',
    'PROTAC',
    'KRAS',
    'remdesivir',
    'oseltamivir',
    'Charcot-Marie-Tooth',
    'antibody therapy',
    'targeted protein degradation',
    'proteomics',
    'glioblastoma',
    'Non-Hodgkin lymphoma'
  ]
}

export default {
  props: {
    placeholderTextOverride: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    initRNG () {
      // const seed = Math.floor(new Date().getTime() / 1000 / 60) // Changes every minute
      // Initialise RNG generator with a seed based on the UNIX timestamp
      const seed = Math.floor(new Date().getTime() / 1000 / 3600 / 24) // Changes every day
      RNG.initialize(seed)
    }
  },
  computed: {
    placeholderText () {
      if (this.placeholderTextOverride) return this.placeholderTextOverride
      // Scoped searches always have a more generic placeholder
      if (this.isScopedSearch) {
        const humanRedableScope = this.$options.filters.singularize(this.$options.filters.humanize(this.state.filter_order[0]))
        if (this.state.index.startsWith('web_pages')) {
          return `Search within the contents of this ${humanRedableScope.toLowerCase()}'s website`
        } else {
          return `Search within this ${humanRedableScope.toLowerCase()}`
        }
      }

      // We want to generate a pseudo-random list of placeholder terms, that changes every day
      this.initRNG() // initialize RNG
      const examples = [] // examples that will be visible in the placeholder text

      // If the index has specific examples, we select from those first
      const indexExamples = PLACEHOLDER_LIST[this.state.index]
      if (indexExamples) {
        const slice = RNG.scrambleArray(indexExamples).slice(0, 3 - examples.length)
        examples.push(...slice)
      }

      // If the examples list is less than 3 long, we select from the 'general examples' list
      if (3 - examples.length > 0) {
        const generalSlice = RNG.scrambleArray(PLACEHOLDER_LIST.general).slice(0, 3 - examples.length)
        examples.push(...generalSlice)
      }

      if (this.$currentUser && this.$currentUser.email) {
        this.$currentUser.email.indexOf('@academiclabs.co') > 0 && Math.random() > 0.999999 && examples.unshift('Big Foot')
      }

      return `Search for e.g. ${examples.join(', ')}`
    }
  }
}
